"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitBonusIntroPage = void 0;
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const OpenSans_1 = require("@nolimit/slot-launcher/bin/loader/font/OpenSans");
const FontStatics_1 = require("@nolimit/slot-launcher/bin/loader/font/FontStatics");
const PromoPanelAssetConfig_1 = require("../config/PromoPanelAssetConfig");
const NolimitPromotionPlugin_1 = require("../NolimitPromotionPlugin");
const GuiDefaults_1 = require("@nolimit/slot-launcher/bin/gui/default/GuiDefaults");
const PromoPanelBaseIntroPage_1 = require("./PromoPanelBaseIntroPage");
const gsap_1 = require("gsap");
const Label_1 = require("@nolimit/slot-launcher/bin/gui/labels/Label");
const NLCStaticText_1 = require("@nolimit/slot-launcher/bin/display/NLCStaticText");
/**
 * Created by jonas on 2020-03-19.
 */
class NolimitBonusIntroPage extends PromoPanelBaseIntroPage_1.PromoPanelBaseIntroPage {
    constructor(data, backgroundColor, header, headerIconName, headerStyle) {
        super(backgroundColor, header, headerIconName, headerStyle);
        const yPos = data.length > 1 ? 0 : 23;
        const ticketContainer = this.createTickets(data);
        ticketContainer.position.set(0, yPos);
        //ticketContainer.scale.set(0.65, 0.65);
        this.addChild(ticketContainer);
        const textIndex = Math.min(1, data.length - 1);
        const texts = [
            "Buy your way into the most exciting feature of the game!",
            "Buy your way into the most exciting features of the game!"
        ];
        const textField = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(texts[textIndex]), GuiDefaults_1.GuiDefaults.INTRO_PAGE_TEXT);
        textField.anchor.x = 1;
        textField.anchor.y = 0.5;
        textField.position.x = -10;
        textField.position.y = 35;
        this.addChild(textField);
    }
    createTickets(data) {
        const container = new PIXI.Container();
        const tickets = [];
        for (let item of data) {
            tickets.push(this.createTicket(item));
        }
        const totalRot = 0.25;
        const totalXDistance = 23;
        const totalYDistance = 78;
        let rotIncrement = 0;
        let rotOffset = 0;
        let test = 0;
        let incrementX = 0;
        let incrementY = 0;
        if (tickets.length > 1) {
            rotIncrement = totalRot / (tickets.length - 1); //Spread between the tickets
            test = -(rotIncrement * (tickets.length - 1)) * 0.5; //Rotation of the whole fan, so the center one is has rot = 0
            rotOffset = -0.05; //Offset so we get a slight tilt to the whole fan.
            incrementX = totalXDistance / (tickets.length - 1);
            incrementY = totalYDistance / (tickets.length - 1);
        }
        const ticketAnimations = [];
        for (let i = 0; i < tickets.length; i++) {
            const ticket = tickets[i];
            const tl = new gsap_1.TimelineLite();
            const endRotation = rotIncrement * i + test + rotOffset;
            tl.add(new gsap_1.TweenLite(ticket, 0.5, {
                x: incrementX * i,
                y: incrementY * i,
                rotation: endRotation,
                ease: gsap_1.Elastic.easeOut.config(1, 0.75)
            }));
            /*    ticket.rotation =  rotIncrement * i + test + rotOffset;
                ticket.x = incrementX * i;
                ticket.y = incrementY * i;
                */
            const priceTag = ticket.getChildByName("priceTag");
            if (priceTag) {
                tl.add(new gsap_1.TweenLite(priceTag, 0.5, {
                    rotation: -endRotation,
                    ease: gsap_1.Elastic.easeOut.config(1, 0.75)
                }), 0);
                priceTag.rotation = -ticket.rotation;
            }
            ticketAnimations.push(tl);
            container.addChild(ticket);
        }
        this._fanAnimation = new gsap_1.TimelineLite({ paused: true });
        this._fanAnimation.add(ticketAnimations, 0);
        return container;
    }
    createTicket(data) {
        const cont = new PIXI.Container();
        const image = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(data.name));
        const ticket = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.INTRO_NOLIMIT_BONUS_TICKET));
        const priceTag = this.makePriceTag(data.price);
        priceTag.name = "priceTag";
        image.position.set(136, 77);
        image.scale.set(0.65, 0.65);
        image.anchor.set(0.5, 0.5);
        priceTag.position.set(254, 10);
        cont.addChild(ticket, image);
        cont.pivot.set(-33, cont.height * 0.5);
        cont.addChild(priceTag);
        return cont;
    }
    makePriceTag(value) {
        const container = new PIXI.Container();
        const text = new NLCStaticText_1.NLCStaticText("x " + value, NolimitBonusIntroPage.PRICE_TAG_STYLE);
        text.anchor.set(0.5, 0.5);
        text.position.set(0, 0);
        const tag = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.INTRO_NOLIMIT_BONUS_PRICE_TAG));
        tag.anchor.set(0.5, 0.4);
        container.addChild(tag, text);
        return container;
    }
    enable(enable) {
        super.enable(enable);
        if (this._fanAnimation) {
            if (enable) {
                this._fanAnimation.play(0);
            }
            else {
                this._fanAnimation.pause(0);
            }
        }
    }
}
NolimitBonusIntroPage.PRICE_TAG_STYLE = new PIXI.TextStyle({
    fontFamily: OpenSans_1.OpenSans.FAMILY,
    fontSize: 20,
    fontStyle: FontStatics_1.FontStyle.NORMAL,
    fontWeight: FontStatics_1.FontWeight.EXTRA_BOLD,
    dropShadow: true,
    dropShadowAngle: 1.57,
    dropShadowColor: "#ef9720",
    dropShadowDistance: 2,
    fill: "#f4f2f3",
    padding: 3,
    stroke: "#FFAA05",
    strokeThickness: 2,
    lineJoin: "round"
});
exports.NolimitBonusIntroPage = NolimitBonusIntroPage;
//# sourceMappingURL=NolimitBonusIntroPage.js.map